import React, { useState, useEffect } from "react";
import herobg from "../assets/herobg.png";
import heroperson from "../assets/heroperson.png";
import shapeless from "../assets/shapeless.png";
import heroimg from "../assets/heroimg.png";
import videohero from "../assets/videohero.mp4";

let textArray = [
  { name: "Build your products", color: "#75e8f0" },
  { name: "Hire software developers", color: "#120065" },
  { name: "Dedicated software teams", color: "#FAAA1E" },
  { name: "Build faster and smarter", color: "#75e8f0" },
  { name: "Hire software developers", color: "#120065" },
  { name: "Remote software Engineers", color: "#FAAA1E" },
  { name: "Scale up your process", color: "#75e8f0" },
  { name: "connect with designers", color: "#120065" },
  { name: "Vetted remote developers", color: "#FAAA1E" },
];

const Hero = () => {
  const [textId, setTextId] = useState(0);

  const Inrement = () => {
    setTextId((id) => id + 1);
  };

  useEffect(() => {
    setInterval(() => {
      Inrement();
    }, 2500);
  }, []);

  let textChange = textArray[textId % textArray.length];

  return (
    <section className="hero no-gutters">
      <div className="h-100 no-gutters">
        <div className="h-100 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div className="container h-100">
            <div className="d-flex hero-content h-100">
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 px-0">
                <h2 style={{whiteSpace: "nowrap"}} className="font-heading mb-50 lh-small text-white font-weight-bolder">
                  Leading software <br /> engineering teams <br />{" "}
                  <span
                    className="font-subhead"
                    style={{ color: textChange.color, whiteSpace: "nowrap" }}>
                    {" "}
                    {textChange.name}.{" "}
                  </span>
                </h2>
                <h5 className="font-normal text-mute">
                  On-demand software engineering teams
                </h5>
                <div className="mt-4 d-flex">
                  <a
                    href="/employer/signup"
                    className="mr-1 font-sm primary-btn lemon-btn large-btn">
                    Build your product{" "}
                    {/* <i className="fas fa-long-arrow-alt-right ml-25 vertical-middle"></i> */}
                  </a>
                  <a
                    href="/developer/signup"
                    className="font-sm secondary-btn large-btn">
                    Become a Developer{" "}
                    {/* <i className="fas fa-long-arrow-alt-right ml-25 vertical-middle"></i> */}
                  </a>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 px-0 hero-img-container">
                <div className="h-100">
                  <img src={heroimg} className="" alt="hero section" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
